import React, { useEffect, useCallback } from 'react';
import { Modal } from 'antd';
import { useNavigate, useLocation, useBlocker } from 'react-router-dom';

const UnsavedChangesGuard = ({ hasUnsavedChanges, onConfirmNavigation, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Utiliser le hook useBlocker de React Router
  // Le blocker retourne un objet avec les méthodes `proceed` et `reset` dans les versions plus récentes de React Router v6
  const blocker = useBlocker(hasUnsavedChanges);
  
  // Gérer l'action de blocage lorsque le blocker est actif
  useEffect(() => {
    if (blocker.state === 'blocked') {
      Modal.confirm({
        title: 'Modif. non enregistrées',
        content: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter sans sauvegarder ?',
        okText: 'Quitter',
        cancelText: 'Rester',
        onOk: () => {
          onConfirmNavigation?.();
          blocker.proceed();
        },
        onCancel: () => {
          blocker.reset();
        },
      });
    }
  }, [blocker, onConfirmNavigation]);

  // Gérer la navigation du navigateur/rafraîchissement
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!hasUnsavedChanges) return;
      
      e.preventDefault();
      e.returnValue = 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?';
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return <>{children}</>;
};

export default UnsavedChangesGuard;